import { BaseModel } from "./base-model";

export default class MCatalogueListItem {
    id: string;
    productId: string;
    productName: string;
    productDescription: string;
    inhouseId: string;
    MediaContent: [];
    disabled: string;
    vendorId: string;
    vendorName: string;
    dateCreated: string;
    dateModified: string;
    productType: string;
    shell: string;
    source: string;
    sourceId: string;
    stores: string;
    poType: string;
    ProductCategoryArray: [];
    StoreArray: [];
    productTypeName: string;
    productPriceRange: []


    constructor(options){
        this.id = options.id || "";
        this.productId = options.productId || "";
        this.productName = options.productName || "";
        this.productDescription = options.productDescription || "";
        this.inhouseId = options.inhouseId || "";
      
        this.disabled = options.disabled || '0';
        this.vendorName = options.vendorName || '';
        this.dateCreated = options.dateCreated || '';
        this.dateModified = options.dateModified || '';
        this.productType = options.productType || '';
        this.shell = options.shell || '';
        this.source = options.source || '';
        this.sourceId = options.sourceId || '';
        this.stores = options.stores || '';
        this.poType = options.poType || '';
   
        this.productTypeName = options.productTypeName || '';
        if (options.MediaContent) {
            this.MediaContent = options.MediaContent;
        } else {
            this.MediaContent = [];
        }
        if (options.StoreArray) {
            this.StoreArray = options.StoreArray;
        } else {
            this.StoreArray = [];
        }
        if (options.ProductCategoryArray) {
            this.ProductCategoryArray = options.ProductCategoryArray;
        } else {
            this.ProductCategoryArray = [];
        }

        this.productPriceRange = options.productPriceRange || [];
    }

}